import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";
export class BurningFruits40_2_2Screen extends SlotGameType1_2_2Screen {}